import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'TabBackBtn',
  props: {
    forceShow: { type: Boolean, default: false }
  },
  setup(__props: any) {

const route = useRoute()
const router = useRouter()



const showBackButton = computed(() => {
  const paths = route.path.split('/')
  if (!paths.length) { return false }
  return paths.filter(p => p != '').length > 1
})

return (_ctx: any,_cache: any) => {
  return (showBackButton.value || _ctx.forceShow)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back())),
        class: "btn btn-link text-dark ms-2 fs-1 pb-0"
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
      ])))
    : _createCommentVNode("", true)
}
}

})